import { Hit, BaseHit } from 'instantsearch.js/es/types';

import { MarkerType, SearchResult } from '../types';

const transformHitsToMarkers = (hits: Hit<BaseHit>[], selected?: number) => {
  const newMarkers: MarkerType[] = [];
  if (hits) {
    hits.forEach((item) => {
      const searchResult = item as SearchResult;
      const latlon: string[] = searchResult.latlon?.[0]?.split(',') || ['0', '0'];
      const location = [latlon[0], latlon[1]];
      const marker: MarkerType = {
        geoLocation: {
          latitude: Number(location[0]),
          longitude: Number(location[1]),
        },
        id: searchResult.objectID,
        title: searchResult.title[0],
        project_type: searchResult.project_type,
        project_status: searchResult.project_status,
        url: searchResult.url[0],
        selected: selected === searchResult.nid[0],
      };
      newMarkers.push(marker);
    });
  }
  return newMarkers;
};

export default transformHitsToMarkers;
